module.exports = __webpack_public_path__ + "static/media/dropdown-icon.50adfba0.svg";